export const productAr = {
  "Veuillez Ajouter des produits": "الرجاء إضافة المنتجات",
  "Titre": "العنوان",
  "Qté": "الكمية",
  "Donner le titre de votre produit": "إعط عنوان المنتج الخاص بك",
  "Donner Une Note sur votre produit": "إعط تقييم على المنتج الخاص بك",

  "Rechercher": "بحث",
  "Rechercher par titre": "بحث حسب العنوان",
  "En stock": "في المخزن",
  
}